import { useState, useEffect } from "react";
import PotentialManager from "../PotentialManager";
import { getCurrentTotal, updateBodyInfo } from "../TableDataHelper";
import { DataType } from "../../../shared/utils/enum";

export const useCropPotential = (selectedStateVendor, updateTotalVolume, reloadScreen) => {
  const [cropSales, setCropSales] = useState();
  const [cropTotal, setCropTotal] = useState();
  const [loadingCropTable, setloadingCropTable] = useState(false);

  useEffect(() => {
    if (cropTotal != null) {
      updateTotalVolume(
        DataType["crop"].id,
        cropTotal.currentYearTotal,
        cropTotal.currentYaraTotal
      );
    }
  }, [cropTotal, updateTotalVolume]);

  useEffect(() => {
    const getData = async () => {
      setloadingCropTable(true);
      setCropSales();
      setCropTotal({
        currentYearTotal: 0,
        currentYaraTotal: 0
      });
      const data = await PotentialManager.listCropPotentials(
        selectedStateVendor,
        new Date().getFullYear()
      );

      if (data) {
        setCropSales(data);
        updateTotals(data);
      }
      setloadingCropTable(false);
    };
    if (selectedStateVendor) getData();
  }, [selectedStateVendor, reloadScreen]);

  const updateTotals = data => {
    const totals = getCurrentTotal(data);
    setCropTotal(totals);
  };

  const updateCropData = (rowId, columnId, newValue) => {
    const newData = updateBodyInfo(cropSales, rowId, columnId, newValue);

    if (newData) {
      setCropSales(newData);
      updateTotals(newData);
    }
  };

  return {
    cropSales,
    loadingCropTable,
    cropTotal,
    updateCropData
  };
};
